/* Preview index — lets you flip between the 3 directions */
import { Link } from "react-router-dom";

export default function PreviewIndex() {
  const cards = [
    {
      to: "/preview/v1",
      tag: "v1 · Electric Operator",
      title: "Blueprint × Linear × Terminal",
      desc: "Black + White + Electric Blue. Engineering-blueprint feel. Pipeline as wired diagram. Mono eyebrows. Space Grotesk display.",
      bg: "bg-[#070809]",
      text: "text-white",
      accent: "#3B82F6",
    },
    {
      to: "/preview/v2",
      tag: "v2 · Studio Orange",
      title: "Editorial × Magazine × Studio",
      desc: "Black + Ivory + Signal Orange. Fraunces serif headlines. Pipeline as a ride from stage 1 to 6. Apple-Music-issue energy.",
      bg: "bg-[#0B0A09]",
      text: "text-[#F5F0E6]",
      accent: "#FF5B1F",
    },
    {
      to: "/preview/v3",
      tag: "v3 · Aperture",
      title: "Apple × Museum × Linear changelog",
      desc: "Off-white canvas + Geist + a single Electric Blue dot. Pipeline as a museum-style centerpiece. Big tiles, calm air.",
      bg: "bg-[#FAFAF7]",
      text: "text-black",
      accent: "#0066FF",
    },
  ];

  return (
    <div className="min-h-screen bg-neutral-950 text-white p-6 md:p-12">
      <div className="max-w-6xl mx-auto">
        <div className="label-eyebrow text-neutral-500">PintaFlow · Design Review</div>
        <h1 className="font-heading text-3xl md:text-5xl tracking-tighter font-medium mt-3">
          Three directions. Pick one.
        </h1>
        <p className="text-neutral-400 mt-3 max-w-xl text-sm leading-relaxed">
          Each variant leads with the Pipeline as the hero. All three answer one question:
          <span className="text-white"> &quot;What does the operating system for serious creators look like?&quot;</span>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
          {cards.map((c) => (
            <Link
              key={c.to}
              to={c.to}
              className={`group rounded-2xl border border-white/10 overflow-hidden hover:border-white/30 transition`}
            >
              <div className={`${c.bg} ${c.text} p-6 h-44 flex flex-col justify-between relative overflow-hidden`}>
                <div className="flex items-center justify-between">
                  <span
                    className="text-[10px] font-mono uppercase tracking-[0.22em]"
                    style={{ color: c.accent }}
                  >
                    {c.tag}
                  </span>
                  <span
                    className="w-2 h-2 rounded-full"
                    style={{ background: c.accent, boxShadow: `0 0 12px ${c.accent}` }}
                  />
                </div>
                <div>
                  <div className="text-xl font-semibold tracking-tight" style={{ color: c.accent }}>
                    {c.title.split(" × ")[0]}
                  </div>
                  <div className="text-sm opacity-70">{c.title.split(" × ").slice(1).join(" × ")}</div>
                </div>
              </div>
              <div className="bg-neutral-900 p-5 text-sm text-neutral-400">
                {c.desc}
                <div className="mt-3 text-white opacity-80 group-hover:opacity-100 group-hover:text-white text-xs font-mono tracking-wider uppercase">
                  Open preview →
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-xs text-neutral-500">
          When you&apos;ve picked one, tell me the version number (v1 / v2 / v3) — I&apos;ll port that visual identity into the
          full app (dashboard, pipeline, vault, swipe, calendar, goals, settings).
        </div>
      </div>
    </div>
  );
}
